import { notFoundRouterRoute } from '@townsquare/404-page-view/__router-route';
import {
	aggGoalDirectoryArchivedRouterRoute,
	aggGoalDirectoryFollowingRouterRoute,
	aggGoalDirectoryRouterRoute,
} from '@townsquare/agg-goals-directory-view/__router-route';
import { appsResource } from '@townsquare/apps-store/resource';
import { appsRoute } from '@townsquare/apps-view/__router-route';
import { popupAuthRoute } from '@townsquare/auth/popup-login';
import { capabilityProviderResource } from '@townsquare/capability-provider/resource';
import { emptyOrNonProvisionedStatusUpdateStateRouterRoute } from '@townsquare/empty-or-not-provisioned-state/__router-route';
import { goalCapabilitiesResource } from '@townsquare/goal-capabilities/resource';
import { goalViewRoute } from '@townsquare/goal-view/__router-route';
import {
	goalDirectoryArchivedRouterRoute,
	goalDirectoryFollowingRouterRoute,
	goalDirectoryRouterRoute,
	goalNoWorkspaceDirectoryRouterRoute,
} from '@townsquare/goals-directory-view/__router-route';
import {
	goalsAppUpdateViewRouterRoute,
	goalsAppSavedViewsUpdatesRouterRoute,
} from '@townsquare/home-view/routes';
import { notificationsRouterRoute } from '@townsquare/notifications-view/__router-route';
import { projectCapabilitiesResource } from '@townsquare/project-capabilities/resource';
import { applyResourcesToRoute, expandGlobalRoute } from '@townsquare/router/create-route';
import {
	GlobalHomePageRoute,
	HomepageRouteType,
	HomepageRoutes,
} from '@townsquare/router/route-types';
import { goalsAppReadingModeRoute } from '@townsquare/routes/reading-mode-view';
import { goalsAppGlobalSearchRoute } from '@townsquare/routes/search-goals-app';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';
import { searchConfigurationResource } from '@townsquare/search-config-resource';
import {
	goalSettingsRouterRoute,
	noWorkspacePersonalSettingsRouterRoute,
} from '@townsquare/settings-view/__router-route';
import { followGoalActionRouterRoute } from '@townsquare/url-actions/follow-goal/__router-route';
import { lookupRedirectActionRouterRoute } from '@townsquare/url-actions/lookup-redirect/__router-route';
import { reactionUpdateActionRouterRoute } from '@townsquare/url-actions/reaction-update/__router-route';
import { searchRedirectActionRouterRoute } from '@townsquare/url-actions/search-redirect/__router-route';

// When adding a new route, please also add it to the route-sanity-check E2E test
export const routeDefinitions: HomepageRoutes = [
	// Actions
	followGoalActionRouterRoute,
	lookupRedirectActionRouterRoute,
	reactionUpdateActionRouterRoute,
	searchRedirectActionRouterRoute,

	// AGG goal directory lives at /agg-goals* (parallel surface, NOT a gate
	// swap of /goals) — see packages/routes/src/route-definitions/agg-goal-directory-view.ts
	// for the rationale. The feature gate still scopes route registration to
	// opted-in tenants. URL-merging (/goals served by either view) is a
	// separate human-driven cutover.
	aggGoalDirectoryRouterRoute,
	aggGoalDirectoryFollowingRouterRoute,
	aggGoalDirectoryArchivedRouterRoute,
	goalDirectoryRouterRoute,
	goalViewRoute,
	goalSettingsRouterRoute,
	goalDirectoryArchivedRouterRoute,
	goalDirectoryFollowingRouterRoute,
	goalsAppUpdateViewRouterRoute,
	goalsAppSavedViewsUpdatesRouterRoute,
	goalsAppGlobalSearchRoute,
	goalsAppReadingModeRoute,
	appsRoute,

	// Fallback
	popupAuthRoute,
	notFoundRouterRoute,
];

export const noWorkspaceRouteDefinitions: GlobalHomePageRoute[] = [
	goalNoWorkspaceDirectoryRouterRoute,
	notificationsRouterRoute,
	emptyOrNonProvisionedStatusUpdateStateRouterRoute,
	noWorkspacePersonalSettingsRouterRoute,

	// Fallback
	notFoundRouterRoute,
];

export const routes: HomepageRouteType[] = routeDefinitions
	.flatMap<HomepageRouteType>((route) => {
		if (route.routeType === 'global') {
			return expandGlobalRoute(route);
		}

		return route;
	})
	.map((route) => {
		if (route.routeType === 'global' || route.routeType === 'site') {
			route = applyResourcesToRoute(route, [
				appsResource,
				rovoEntitlementResource,
				searchConfigurationResource,
				capabilityProviderResource,
				projectCapabilitiesResource,
				goalCapabilitiesResource,
			]);
		}

		return route;
	});

export const noWorkspaceRoutes: HomepageRouteType[] = noWorkspaceRouteDefinitions
	.flatMap<HomepageRouteType>((route) => {
		if (route.routeType === 'global') {
			return expandGlobalRoute(route);
		}

		return route;
	})
	.map((route) => {
		if (route.routeType === 'global' || route.routeType === 'site') {
			route = applyResourcesToRoute(route, [
				appsResource,
				rovoEntitlementResource,
				searchConfigurationResource,
				projectCapabilitiesResource,
				goalCapabilitiesResource,
			]);
		}

		return route;
	});
